// extracted by mini-css-extract-plugin
export var content = "_nq-1";
export var noScroll = "_nq-3";
export var paper = "_nq-0";
export var scrollable = "_nq-2";